import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import Paginator from 'react-hooks-paginator';

import { Loading } from '../ui/Loading';
import { Sector } from './Sector';

export const FileSectoresList = ({ sectores }) => {

    const pageLimit = 10;

    const columns   = useSelector( state => state.gestion.columnsFileSectores);    


    //PAGINACION
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [data] = useState([]);
    const [currentData, setCurrentData] = useState([]);

    
    useEffect(() => {
        setCurrentData(sectores.slice(offset, offset + pageLimit));
    }, [offset, data, sectores]);
    
    if (!sectores && !columns ) return <Loading />;
    
    return (
        <div>
            {   sectores.length > 0 
                        ?  
                        
                        <>
                            <table className="table table-dark">
                                        <thead className="thead-dark">
                                            <tr>
                                                {
                                                    columns.map( (c, index) => (                                    
                                                        <th className="text-uppercase" key={index} scope="col">{c.dataField}</th>
                                                    ))
                                                }
                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            currentData.map( (sector, index) => (
                                                <Sector 
                                                    key   = {index}
                                                    {...sector}
                                                />
                                            ))
                                        }
                                        </tbody> 
                            </table>

                            <Paginator
                                totalRecords={sectores.length}
                                pageLimit={pageLimit}
                                pageNeighbours={2}
                                setOffset={setOffset}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                        </> 
                        : null }
        </div>
    )
}
